// src/AvailabilityModal.jsx
import React, { useState } from "react";
import { Dialog } from "@headlessui/react";
import { Button } from "../components/ui/button";

const daysOfWeek = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

const AvailabilityModal = ({ isOpen, onClose, onSubmit }) => {
  const [selectedDays, setSelectedDays] = useState([]);
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");

  const toggleDay = (index) => {
    setSelectedDays((prev) =>
      prev.includes(index)
        ? prev.filter((d) => d !== index)
        : [...prev, index]
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!start || !end || selectedDays.length === 0) return;

    selectedDays.forEach((day) => {
      onSubmit({ day_of_week: day, start_time: start, end_time: end });
    });

    setSelectedDays([]);
    setStart("");
    setEnd("");
    onClose();
  };

  return (
    <Dialog open={isOpen} onClose={onClose} className="fixed z-50 inset-0 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4">
        {/* Replace old Dialog.Overlay with this */}
        <div className="fixed inset-0 bg-black/30" aria-hidden="true" />

        <Dialog.Panel className="relative bg-white rounded-lg shadow-xl w-full max-w-md p-6 z-10">
          <Dialog.Title className="text-lg font-semibold mb-4">Set Your Weekly Availability</Dialog.Title>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">Select Days</label>
              <div className="grid grid-cols-2 gap-2">
                {daysOfWeek.map((day, index) => (
                  <label key={index} className="flex items-center gap-2">
                    <input
                      type="checkbox"
                      checked={selectedDays.includes(index)}
                      onChange={() => toggleDay(index)}
                    />
                    {day}
                  </label>
                ))}
              </div>
            </div>

            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">Start Time</label>
              <input
                type="time"
                value={start}
                onChange={(e) => setStart(e.target.value)}
                className="w-full border border-gray-300 rounded px-3 py-2"
              />
            </div>

            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">End Time</label>
              <input
                type="time"
                value={end}
                onChange={(e) => setEnd(e.target.value)}
                className="w-full border border-gray-300 rounded px-3 py-2"
              />
            </div>

            <div className="flex justify-end gap-2">
              <Button type="button" variant="outline" onClick={onClose}>
                Cancel
              </Button>
              <Button type="submit">Save</Button>
            </div>
          </form>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};

export default AvailabilityModal;